module.exports = __webpack_public_path__ + "static/octupus-1-4a5b93270b2f835cf42476e76b08d76b.jpg";